import { Injector, Type } from "@angular/core";
import { createCustomElement } from "@angular/elements";
import { VideoJsPlayerComponent } from "src/app/shared/components/video-js-player/video-js-player.component";
import { YoutubePlayerComponent } from "src/app/shared/components/youtube-player/youtube-player.component";

export const BIND_YOUTUBE_PLAYER_ELEMENT = 'app-bind-youtube-player';
export const BIND_VIDEO_JS_PLAYER_ELEMENT = 'app-bind-video-js-player';

export class CustomCourseElements {
  private static alreadyDefined = false;

  constructor(private injector: Injector) {}

  public bindElements(content: string) {
    content = this.bindYoutubePlayer(content);
    content = this.bindVideoJsPlayer(content);
    return content;
  }

  public initElements() {
    if (CustomCourseElements.alreadyDefined) {
      return;
    }

    this.defineElement(BIND_YOUTUBE_PLAYER_ELEMENT, YoutubePlayerComponent);
    this.defineElement(BIND_VIDEO_JS_PLAYER_ELEMENT, VideoJsPlayerComponent);

    CustomCourseElements.alreadyDefined = true;
  }

  private defineElement(name: string, component: Type<any>) {
    const element = createCustomElement(component, { injector: this.injector });
    customElements.define(name, element);
  }

  private bindYoutubePlayer(content: string) {
    const $content = $('<section>').html(content);
    const $youtubeIframes = $content.find('iframe[src*="youtube.com/embed/"]');

    if ($youtubeIframes.length === 0) {
      return content;
    }

    const tag = BIND_YOUTUBE_PLAYER_ELEMENT;

    $youtubeIframes.each(function() {
      $(this).replaceWith(
        this.outerHTML
          .replace('<iframe', `<${tag} autoplay`)
          .replace('</iframe>', `</${tag}>`)
      );
    });

    const html = $content.html();
    return html;
  }

  private bindVideoJsPlayer(content: string) {
    const $content = $('<section>').html(content);
    const $video = $content.find('video');

    if ($video.length === 0) {
      return content;
    }

    const tag = BIND_VIDEO_JS_PLAYER_ELEMENT;

    $video.each(function() {
      $(this).replaceWith(
        this.outerHTML
          .replace('<video', `<${tag} autoplay`)
          .replace('</video>', `</${tag}>`)
      );
    });

    const html = $content.html();
    return html;
  }
}
